// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".2b437ee3ba1156ac3ee3ff30c9d6fb37.js";
};